import { INTEREST_SET_STATISTIC } from './actionTypes';
import { interestApi } from 'helpers/api/interest';

export const Interest = {
  getInterestStatisticList: (query = {}) => async (dispatch) => {
    return interestApi
      .statisticList(query)
      .then(({ data } = {}) => {
        dispatch(Interest.setStatisticAction(data));
      })
      .catch(() => {
        dispatch(Interest.setStatisticAction([]));
      });
  },

  setStatisticAction: (payload) => ({
    type: INTEREST_SET_STATISTIC,
    payload,
  }),
};
